export default __webpack_public_path__ + "static/media/screen8.c7c2b4e4.png";